import { listOption } from '@/api/base/baseCargoMaterial'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOption)
